import SectionFeature from './SectionFeature'

export default SectionFeature
